/*
 * @Author: your name
 * @Date: 2021-03-10 15:35:09
 * @LastEditTime: 2021-04-15 10:38:52
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zlt-front-end\src\Master\router\index.js
 */
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '*',
      redirect: '/'
    },
    {
      path: '/',
      component: resolve => require(['../views/login/login.vue'], resolve),
      meta: { title: '自述文件' },
      children: [
        {
          path: '/home',
          component: resolve => require(['../views/home/index'], resolve),
          meta: { title: '首页' }
        },
        
      ]
    },
    {
      path: '/loading',
      component: resolve => require(['../views/login/loading.vue'], resolve),
      meta: { title: '中转页' }
    },
    {
      path: '/binding',
      component: resolve => require(['../views/login/binding.vue'], resolve),
      meta: { title: '微信绑定' }
    },
    {
      path: '/toInform',
      component: resolve => require(['../views/userC/toInform.vue'], resolve),
      meta: { title: '出团通知书' }
    },
    {
      path: '/t',
      component: resolve => require(['../views/userC/toInformMessage.vue'], resolve),
      meta: { title: '出团通知书' }
    },
    {
      path: '/previewContract',
      component: resolve => require(['../views/previewContract/index.vue'], resolve),
      meta: { title: '合同' }
    },
    {
      path: '/mp-poster/bannerPoster',
      component: resolve => require(['../views/mp-poster/bannerPoster.vue'], resolve),
      meta: { title: '海报' }
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/Master/router/index.js